import React, { useEffect, useState } from 'react';

import { SystemCard } from '../../components/notifications/systemCard';
import config from '../../config';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { useNotifications } from '../../context/NotificationContext';
import DotSpinner from '../../components/shared/DotSpinner';

const Notifications = () => {
  const axiosPrivate = useAxiosPrivate();

  const { counts, updateCounts, setLoading: setGlobalLoading } = useNotifications();

  const [systemNotifications, setSystemNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  const refreshCounts = async () => {
    try {
      const response = await axiosPrivate.get(config.API.NOTIFICATIONS.COUNTS);
      if (response.data?.status === 'success') {
        updateCounts(response.data.data);
      }
    } catch (err) {
      console.error('Error refreshing counts:', err);
    }
  };

  useEffect(() => {
    const loadCounts = async () => {
      try {
        setGlobalLoading(true);
        const response = await axiosPrivate.get(config.API.NOTIFICATIONS.COUNTS);

        if (response.data?.status === 'success') {
          updateCounts(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching notification counts:', error);
      } finally {
        setGlobalLoading(false);
      }
    };

    const timer = setTimeout(() => {
      loadCounts();
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const loadSystemNotifications = async () => {
      setLoading(true);
      try {
        const response = await axiosPrivate.get(config.API.NOTIFICATIONS.LIST, {
          params: { type: 'system', limit: 50 }
        });

        if (response.data?.status === 'success') {
          const items = response.data.data.items || [];

          // сразу показываем как прочитанные в UI
          setSystemNotifications(items.map((n) => ({ ...n, seen: true })));

          // авто-прочтение всех непрочитанных на бэке
          const unread = items.filter((n) => !n.seen);
          if (unread.length > 0) {
            await Promise.all(
              unread.map((n) =>
                axiosPrivate
                  .post(config.API.NOTIFICATIONS.MARK_READ(n._id))
                  .catch((err) => console.error('mark read error', err))
              )
            );

            refreshCounts();
          }
        }
      } catch (error) {
        console.error('Error fetching notifications:', error);
      } finally {
        setLoading(false);
      }
    };

    loadSystemNotifications();
  }, []);

  if (loading) {
    return (
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center justify-center w-full text-white">
        <DotSpinner />
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col items-center">
      {systemNotifications.length > 0 ? (
        systemNotifications.map((notification) => (
          <div key={notification._id} className="border-b border-[#233636] w-full">
            <SystemCard notification={notification} onRead={() => {}} option={3} />
          </div>
        ))
      ) : (
        <div className="flex flex-col justify-center items-center h-[400px] text-white text-center px-4 gap-7 font-raleway">
          <img src="/icons/bell.svg" className="size-[48px]" />
          <div>
            <h4 className="text-[24px] font-raleway font-medium">Нет уведомлений</h4>
            <p>Здесь появятся уведомления</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Notifications;
